// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import store from "./store/store";
import 'bootstrap';
import 'jquery/src/jquery.js';
import 'popper.js/dist/popper.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/css/app.css';
import './assets/css/doc.css';

Vue.config.productionTip = false
Vue.use(VueResource);

const URL = process.env.ROOT_URL;

Vue.http.options.root = (URL)
    ? URL
    : window.location.protocol + "//" + window.location.hostname+process.env.PART_URL;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js